import { Box, makeStyles, Theme, Typography, useMediaQuery } from "@material-ui/core";
import { FC, memo } from "react";
import { AppBar, AppBarProps } from "react-admin";

import useIsAcademy from "../../hooks/useIsAcademy";
import useIsGym from "../../hooks/useIsGym";
import useIsEntertainment from "../../hooks/useIsEntertainment";
import { areEqual } from "../../utils/generic";
import GymDropdownNotificationList from "../../pages/Gym/GymNotifications/GymDropdownNotificationList";
import AcademyDropdownNotificationList from "../../pages/Academies/AcademyNotifications/AcademyDropdownNotificationList";
import EntertainmentDropdownNotificationList from "../../pages/EntertainmentsVendors/EntertainmentNotifications/EntertainmentDropdownNotificationList";
import MyUserMenu from "./UserMenu";
import useIsSportsClub from "../../hooks/useIsSportsClub";
import SportClubDropdownNotificationList from "../../pages/SportsClubs/SportsClubsNotifications/SportClubDropdownNotificationList";
import CoachDropdownNotificationList from "../../pages/Coaches/CoachesNotifications/CoachDropdownNotificationList";
import BrandDropdownNotificationList from "../../pages/Brands/BrandsNotifications/BrandDropdownNotificationList";
import useIsCoach from "../../hooks/useIsCoach";
import useIsStore from "../../hooks/useIsStore";
import { MuteNotifications } from "../../shared/BaseNotificationList/";
import useIsAdmin from "../../hooks/useIsAdmin";

const useStyles = makeStyles((theme) => ({
  appBar: {
    display: "flex",
    padding: theme.spacing(1, 0),
    boxShadow: "none !important",
  },
  title: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    fontSize: 16,
    flex: 1,
  },
}));

const MyAppBar: FC<AppBarProps> = (props) => {
  const classes = useStyles();
  const { isAdmin } = useIsAdmin();
  const { isGym } = useIsGym();
  const { isAcademy } = useIsAcademy();
  const { isCoach } = useIsCoach();
  const { isSportsClub } = useIsSportsClub();
  const { isEntertainment } = useIsEntertainment();
  const { isStore } = useIsStore();
  const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down("xs"));

  return (
    <AppBar userMenu={<MyUserMenu />} {...props} className={classes.appBar} color="primary" position="static">
      <Box mr="auto">{!isXs && <Typography color="inherit" className={classes.title} id="react-admin-title" />}</Box>
      {!isAdmin && <MuteNotifications />}
      {isGym && <GymDropdownNotificationList />}
      {isAcademy && <AcademyDropdownNotificationList />}
      {isEntertainment && <EntertainmentDropdownNotificationList />}
      {isSportsClub && <SportClubDropdownNotificationList />}
      {isCoach && <CoachDropdownNotificationList />}
      {isStore && <BrandDropdownNotificationList />}
    </AppBar>
  );
};

export default memo(MyAppBar, areEqual);
